import React from "react";
import PropTypes from "prop-types"; // Import PropTypes for prop type validation
import exclamatoryRed from "../images/exclamatoryRed.png"; // Update the path as necessary
import closeIconImage from "../images/popup_close.png"; // Import your custom close icon image
import '../styles/RejectPopUp.css'; // Import the CSS file

const RejectPopup = ({ open, onClose, onReject }) => {
  if (!open) return null; // Return null if the popup is not open

  return (
    <div className="dialog-overlay">
      <div className="dialog">
        <div className="dialog-header">
          <img
            src={closeIconImage}
            alt="Close"
            onClick={onClose}
            className="close-icon"
            aria-label="Close dialog"
          />
        </div>
        <div className="report-problem-section">
          <img
            src={exclamatoryRed}
            alt="Report Problem"
            className="report-problem-icon"
          />
          <div className="dialog-title">You are about to reject a user</div>
          <p className="dialog-subtitle">
            Are you sure you want to reject this user? This action cannot be undone.
          </p>
        </div>
        <div className="dialog-actions">
          <button onClick={onClose} className="cancel-button">
            Cancel
          </button>
          <button onClick={onReject} className="reject-button" aria-label="Reject user">
            Reject
          </button>
        </div>
      </div>
    </div>
  );
};

// Prop types validation
RejectPopup.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onReject: PropTypes.func.isRequired,
};

export default RejectPopup;
